import { Dispatch } from "redux";
import { ENotificationType } from "../../Model/ENotificationType";
import { ToastReduxState } from "../reducers/NotificationReducer";
export enum ENotificationAction {
  SEND_NOTIFICATION = "SEND_NOTIFICATION",
  REMOVE_NOTIFICATION = "REMOVE_NOTIFICATION",
  SET_TOAST = "SET_TOAST",
}

export interface NotificationAction {
  type: ENotificationAction;
  notification?: {
    type: ENotificationType;
    message?: string;
  };
  toast?: ToastReduxState;
}

export function sendNotification(
  type: ENotificationType,
  message?: string
): NotificationAction {
  return {
    type: ENotificationAction.SEND_NOTIFICATION,
    notification: {
      type: type,
      message: message,
    },
  };
}

export function removeNotification(): NotificationAction {
  return {
    type: ENotificationAction.REMOVE_NOTIFICATION,
  };
}

interface ShowToast extends Omit<ToastReduxState, "open"> {}
export function showToast(arg: ShowToast) {
  return (dispatch: Dispatch) => {
    const toast: ToastReduxState = {
      open: true,
      ...arg,
    };

    setTimeout(() => {
      dispatch(hideToast());
    }, arg.duration);

    dispatch({
      type: ENotificationAction.SET_TOAST,
      toast,
    });
  };
}

export function hideToast(): NotificationAction {
  const toast: ToastReduxState = {
    open: false,
    message: "",
    duration: 2000,
    variant: "success",
  };
  return {
    type: ENotificationAction.SET_TOAST,
    toast,
  };
}
